import { render, staticRenderFns } from "./Step8Attachment.vue?vue&type=template&id=c70b3152"
import script from "./Step8Attachment.vue?vue&type=script&lang=js"
export * from "./Step8Attachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports